/* eslint-disable better-mutation/no-mutation */

import { createSlice } from '@reduxjs/toolkit';
import getInitialState, { getInitialServerLanguage } from './initial-state';
import type { LanguageState } from 'tradera/state/language/types';
import { DEFAULT_LANGUAGE } from 'tradera/lang/constants.mjs';

const initialState: LanguageState = {
    preferred: {
        languageCodeIso2: DEFAULT_LANGUAGE,
        displayName: 'Svenska'
    },
    available: [],
    automaticTranslationPreferred: false,
    memberCountryCodeIso2: null
};

const languageSlice = createSlice({
    name: 'language',
    initialState,
    reducers: {
        initialize: (_state, { payload }) => {
            return getInitialState(payload);
        },
        initServerLanguage: (_state, { payload }) => {
            return getInitialServerLanguage(payload);
        },
        setAutomaticTranslationPreferred: (state, { payload }) => {
            state.automaticTranslationPreferred =
                payload.automaticTranslationPreferred;
        }
    }
});

export const {
    initialize,
    initServerLanguage,
    setAutomaticTranslationPreferred
} = languageSlice.actions;
export default languageSlice.reducer;
